export class RestorationTaxAbatementRenewal {
  affidavitInvestmentTotal: number;
  isDescriptionRight: boolean;
  legalDescriptionOfProperty: string;

  constructor() {}
}
